export function AirtableIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
      <mask id="mask0_4217_5529" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="16">
        <path d="M19.6712 0H0.5V16H19.6712V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_4217_5529)">
        <path
          d="M9.03304 0.201743L1.89791 3.1567C1.4943 3.31526 1.50872 3.87742 1.89791 4.03598L9.06187 6.87562C9.69611 7.12066 10.388 7.12066 11.0222 6.87562L18.1862 4.03598C18.5898 3.87742 18.5898 3.31526 18.1862 3.1567L11.0511 0.201743C10.4168 -0.0721306 9.69611 -0.0721306 9.03304 0.201743Z"
          fill="#FCB400"
        />
      </g>
      <mask id="mask1_4217_5529" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="16">
        <path d="M19.6712 0H0.5V16H19.6712V0Z" fill="white" />
      </mask>
      <g mask="url(#mask1_4217_5529)">
        <path
          d="M10.6914 8.43235V15.5242C10.6914 15.8558 11.0374 16.0864 11.3401 15.9711L19.3256 12.872C19.513 12.7999 19.6283 12.6269 19.6283 12.4251V5.33325C19.6283 5.00172 19.2824 4.77109 18.9797 4.8864L10.9941 7.9855C10.8067 8.05757 10.6914 8.23055 10.6914 8.43235Z"
          fill="#18BFFF"
        />
      </g>
      <path
        d="M8.83153 8.79281L6.46757 9.93154L6.22252 10.0469L1.22072 12.4541C0.903604 12.6126 0.5 12.382 0.5 12.0216V5.36218C0.5 5.23245 0.572072 5.13154 0.658558 5.04506C0.687387 5.01623 0.730631 4.97299 0.773874 4.95857C0.889189 4.8865 1.06216 4.87208 1.20631 4.92974L8.78829 7.92794C9.17748 8.07209 9.20631 8.61983 8.83153 8.79281Z"
        fill="#F82B60"
      />
      <path
        d="M8.83118 8.79281L6.46721 9.93155L0.658203 5.03065C0.687032 5.00182 0.730276 4.95858 0.773519 4.94417C0.888834 4.87209 1.06181 4.85768 1.20595 4.91534L8.78793 7.91353C9.17712 8.07209 9.20595 8.61984 8.83118 8.79281Z"
        fill="black"
      />
    </svg>
  );
}
